<template>
  <div class="wrap" :class="{'toUser': showUser}">
    <car-headerbar :title="query.edit || query.templateSetting ? '查看范围设置' : '发送范围设置'" :isCustomLeft="isCustomLeft"/>
    <me-field
        class="me_field"
        :is-link="query.update ? false : true"
        :clickable="false"
        input-align="right"
        :border="false"
        readonly
        name="picker"
        :label="query.edit || query.templateSetting ? '查看范围类型' : '发送范围类型'"
        :placeholder="sendType.text"
        @click="sendTypeClick"
    />
    <me-popup v-model="showPop" position="bottom">
        <me-picker
            :title="query.edit || query.templateSetting ? '查看范围类型' : '发送范围类型'"
            show-toolbar
            :columns="columns"
            :default-index="getdefaultIndex(sendType.value)"
            @confirm="(value) => onConfirmPicker(value)"
            @cancel="showPop = false"
        />
    </me-popup>
    <div class="send-range-setting">
        <me-field
            :border="false"
            readonly
            name="text"
            :label="`${tableHeadrCode[sendType.value] || '部门'}列表`"
        />
        <span v-if="sendType.value === 'user'" @click="showBatchAdd = true" class="batch-add">批量添加</span>
    </div>
    <div class="search_input" >
        <me-search
            v-model="value"
            placeholder="请输入搜索关键词"
            readonly
            @click="searchFocus"
        />
        <div class="table-wrap">
            <table class="table">
                <tr>
                    <th align="center" class="all">{{`${tableHeadrCode[sendType.value] || '部门'}`}}编码</th>
                    <th align="center" class="all" v-if="sendType.value !== 'rank'">{{`${tableHeadrCode[sendType.value] || '部门'}`}}名称</th>
                    <th align="center" class="all" v-if="sendType.value === 'dept'" >{{'含子部门'}}</th>
                    <th align="center" class="all">操作</th>
                </tr>
                <tr v-for="(item, index) in tableData" :key="index">
                    <td>{{item.rangeCode}}</td>
                    <td class="max-width" v-if="sendType.value !== 'rank'">{{item.rangeName}}</td>
                    <td v-if="sendType.value === 'dept'" >
                        <me-switch
                            v-model="item.isSubDept"
                            active-color="#06B455"
                            inactive-color="#DBDBDB"
                            size="24"/>
                    </td>
                    <td @click="delItem(item, index)">移除</td>
                </tr>
                <tr v-if="tableData.length === 0">
                    <td colspan="4" align="center" class="all blank">暂无数据</td>
                </tr>
            </table>
        </div>
    </div>
    <me-popup v-model="showUser" position="bottom" >
        <searchCheckbox v-model="resultList" @confirm="confirmCheckbox" :sendType="sendType.value"></searchCheckbox>
    </me-popup>
    <me-popup
        class="batch-add-popup"
        v-model="showBatchAdd" 
        position="bottom" 
        closeable 
        :style="{ height: '80%' }"
        close-icon-position="top-right"
        title="批量添加员工"
        @closed="handleBatchAddClosed">
        <div class="batch-add-content">
            <div class="batch-add-content-item">
                <div class="batch-add-content-item-label">输入邮箱前缀：</div>
                <textarea
                    class="batch-add-textarea"
                    v-model="batchAddEmailPrefix"
                    placeholder="多个中间用英文“,”间隔，例如zhangsan,lisi"
                    clearable
                    :autosize="false"
                />
                <div class="batch-add-content-item-label">
                    异常账号：
                    <span>{{ batchAddDataFailList.join(',') }}</span>
                </div>
            </div>
        </div>
        <confirm @confirm="batchAddConfirm"/>
    </me-popup>
    <confirm @confirm="confirm"/>
  </div>
</template>

<script>
import { Questionnaire } from '@/network'
import { Toast } from '@guazi-fe/melon'
import { mixin } from '@/mixins'
import browser from '@/util/browser'
import debounce from '@/util/debounce'
import { addClass2, removeClass2 } from '@/util/status-util'
import searchCheckbox from '../compontents/search_checkbox.vue'
import confirm from '../compontents/confirm.vue'

export default {
    data() {
        return {
            value1: false,
            initSearchCheckbox: false,
            resultList: [],
            sendTypeCol: [],
            showPop: false,
            value: '',
            tableData: [],
            data: {},
            showUser: false,
            sendType: {
                text: '未设置',
                value: '',
            },
            columns: [
                {
                    text: '部门',
                    value: 'dept',
                },
                {
                    text: '员工',
                    value: 'user',
                },
                {
                    text: '职级',
                    value: 'rank',
                },
            ],
            tableHeadrCode: {
                dept: '部门',
                user: '员工',
                rank: '职级'
            },
            isCustomLeft: false,
            showBatchAdd: false,
            batchAddEmailPrefix: '',
            batchAddDataFailList: [],
        }
    },
    mixins: [mixin],
    components: {
        searchCheckbox,
        confirm
    },
    created() {
        if (this.query.sendType) {
            this.sendType.text = this.query.sendType === 'dept' ? '部门' : this.query.sendType === 'user' ? '人员' : '职级'
            this.sendType.value = this.query.sendType
        }
        if (this.sendType.value) {
            let obj = this.$store.state.rangeList.find(item => item.sendType === this.sendType.value)
            if (obj) {
                this.tableData = obj.rangeList
                this.resultList = this.tableData.map(item => item.rangeCode)
            }
        }

        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp

        this.getSendTypeColDisabled()
        removeClass2('body', 'loading')
    },
    mounted() {},
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        limitObj() {
            return [this.realName]
        },
        query() {
            return this.$route.query
        },
    },
    methods: {
        batchAddConfirm() {
            Questionnaire.getEmailPrefixList({
                tid: this.tid,
                prefixes: this.batchAddEmailPrefix,
            }).then((res) => {
                const { data, code, message } = res.data
                if (code == 'S00000') {
                    this.batchAddDataFailList = data.failedPrefixes
                    if (!this.batchAddDataFailList.length) {
                        this.showBatchAdd = false
                        const tableDataTemp = data.successList.map(item => ({rangeCode: item.empId, rangeName: item.name, deptName: item.deptName}))
                        const merged = this.tableData.concat(tableDataTemp)
                        const seen = new Map()
                        this.tableData = merged.filter(item => {
                            if (seen.has(item.rangeCode)) {
                                return false
                            }
                            seen.set(item.rangeCode, true)
                            return true
                        })
                        this.resultList = this.tableData.map(item => item.rangeCode)
                        this.batchAddEmailPrefix = ''
                    }
                } else {
                    Toast.fail(message)
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        sendTypeClick() {
            // 如果是编辑不能修改
            if (this.$route.query.update && this.$route.query.update === 'update') {
                return
            }
            this.showPop = true
        },
        getSendTypeColDisabled() {
            let rangeList = this.$store.state.rangeList || []
            let sendTypelist = rangeList.map(item => item.sendType)
            if (!this.$route.query.update) {
                let obj = this.columns.find(item => sendTypelist.indexOf(item.value) === -1)
                this.sendType = obj
            }
            this.columns.forEach(item => {
                if (sendTypelist.indexOf(item.value) !== -1) {
                    item.disabled = true
                }
            });
        },
        confirm() {
            let rangeListItem = {}
            let query = {}
            if(this.tableData.length !== 0 || !this.tableData) {
                rangeListItem.sendType = this.sendType.value
                rangeListItem.rangeContent = this.tableData.map(item => item.rangeName).join('、')
                rangeListItem.rangeList = this.tableData
                this.$store.commit('updateRangeList', rangeListItem)
                query = {
                    updateRange: '1',
                }
            }
            if (this.query.edit) {
                query.edit = this.query.edit
            }
            if (this.query.templateSetting) {
                query.templateSetting = this.query.templateSetting
                query.updateLabel = this.query.updateLabel
            }
            this.$router.replace({
                name: 'sendingRange',
                params: {
                    pageId: this.$route.params.pageId,
                },
                query
            })
        },
        delItem(item, index) {
            this.tableData.splice(index, 1)
            this.resultList = this.tableData.map(item => item.rangeCode)
        },
        searchFocus() {
            if (!this.sendType.value) {
                Toast.fail(this.query.edit || this.query.templateSetting ? '请先选择查看范围类型' : '请先选择发送范围类型')
                return
            }
            this.showUser = true
        },
        onConfirmPicker(data) {
            if (data.value !== this.sendType.value) {
                this.tableData = []
                this.resultList = []
                this.value = ''
            }
            this.sendType = {...data}
            if (this.sendType.value) {
                let obj = this.$store.state.rangeList.find(item => item.sendType === this.sendType.value)
                if (obj) {
                    this.tableData = obj.rangeList
                }
            }
            this.showPop = false
        },
        getdefaultIndex(value) {
            return this.columns.findIndex(item => item.value === value)
        },
        confirmCheckbox(list, value) {
            this.value = value
            // 合并现有数据和新选择的数据，并根据 rangeCode 去重
            const merged = this.tableData.concat(list)
            const seen = new Map()
            this.tableData = merged.filter(item => {
                if (seen.has(item.rangeCode)) {
                    return false
                }
                seen.set(item.rangeCode, true)
                return true
            })
            this.resultList = this.tableData.map(item => item.rangeCode)
            this.showUser = false
        },
        handleBatchAddClosed() {
            this.showBatchAdd = false
        },
    },
   
}
</script>
<style lang="scss">
    .batch-add-popup .me-icon {
        position: absolute;
    }
</style>
<style lang="scss" scoped>
    .send-range-setting {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .batch-add {
            color: #06B455;
            font-size: 14px;
            cursor: pointer;
            margin-right: 22px;
            white-space: nowrap;
            text-decoration: underline;
        }
    }
    .max-width {
        width: 120px;
        padding: 0px 5px;
    }
    ::v-deep .me-switch {
        margin-top: 0.2rem;
    }
    .addPadding {
        padding-bottom: 400PX!important;
    }
    .wrap{
        position: relative;
        background: #fff;
        height: 100%;
    }
    .white{
        z-index: 1!important;
        background: #fff!important;
        position: fixed;
        width: 100%;
        height: 80%;
        left: 0;
        bottom: 0;
    }
    .table-wrap{
        background: #fff;
        padding: .42rem 0px;
        line-height: .74rem;
    }
    .toUser ::v-deep .me-popup--bottom{
        padding:16px 16px 45px;
        height: 80%;
        box-sizing: border-box;
    }
    .table{
        width: 100%;
        border-top: 1PX solid #DBDBDB;
        border-left: 1PX solid #DBDBDB;
        border-collapse: collapse;
        th {
            border-bottom: 1PX solid #DBDBDB;
            border-right: 1PX solid #DBDBDB;
        }
        td{
            border-bottom: 1PX solid #DBDBDB;
            border-right: 1PX solid #DBDBDB;
            // padding-left: .2rem;
            color: #5F6670;
            font-size: .32rem;
            text-align: center;
        }
        .all{
            line-height: 1.17rem;
            background: #F6F6F6;
            color: #333333;
            font-size: .37rem;
        }
        .blank {
            line-height: 1rem;
        }
    }
    ::v-deep .me-cell{
        padding: 0 22px;
        line-height: 52px;
        font-size: 14px;
    }
    .me_field {
        ::v-deep .me-icon {
            font-size: 0.42667rem;
            line-height: 1.42rem;
        }
    }

    .search_input {
        padding: 0px 18px;
        background-color: #fff;
        position: relative;
        padding-bottom: 60px;
        
        ::v-deep .me-search {
            padding: 0;
        }
        ::v-deep .me-search__content {
            padding-left: 0px;
        }
        ::v-deep .me-cell{
            padding: 0 10px;
            line-height: 40px;
            font-size: 14px;
        }
        ::v-deep .me-icon {
            font-size: 0.42667rem;
            line-height: 40px;
        }
    }

    .batch-add-content {
        padding: 16px;
        height: calc(100% - 100px - 130px);
        overflow: auto;
        .batch-add-content-item {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
        .batch-add-content-item-label {
            font-size: 14px;
            color: #333;
            font-weight: 500;
            span {
                color: red;
            }
        }
        .batch-add-textarea {
            width: 100%;
            min-height: 120px;
            border: 1px solid #DBDBDB;
            border-radius: 6px;
            padding: 12px;
            font-size: 14px;
            line-height: 20px;
            resize: vertical;
            box-sizing: border-box;
            height: 200px;
        }
    }

</style>
